import { Col, Modal, Row, Spin, Table, Tabs } from "antd";
import React, {
  useState,
  useCallback,
  useRef,
  useMemo,
  useEffect,
} from "react";
import styled from "styled-components";
import AnswerForm from "../Template/AnswerForm";
import { ButtonFilled, ButtonOutlined } from "reusableComponent/UIButtons";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import { RightOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { getAllDepartmentList, getUserInfo } from "redux/selectors";
import { CALL_API } from "common/API";
import { STATUS_CODE } from "common/Constants";
import dayjs from "dayjs";
import ViewKpi from "./ViewKpi";
import UserFloatingButton from "../UserFloatingButton";
import COLORS from "common/Colors";
import MainQuestionnaireTable from "./MainQuestionnaireTable";
import KPIHistory from "../KPIHistory";
import FloatingHistoryButton from "./FloatingHistoryButton";

const AttendWrap = styled.div`
  position: relative;
  height: calc(100vh - 150px);
  .text-bold {
    font-weight: 500;
  }
  .nodata {
    text-align: center;
    background: #f5f5f5;
    padding: 30px 0px;
    border-radius: 10px;
  }
  .ant-tabs-nav {
    border-radius: 5px;
    font-weight: 500;
    color: ${COLORS.TEXT.PRIMARY};
  }
  .ant-tabs-tab {
    font-size: 16px;
    &:hover {
      color: ${COLORS.TEXT.PRIMARY};
    }
  }
  .ant-tabs-ink-bar {
    background: ${COLORS.TAB};
    font-weight: bold;
    position: absolute;
    bottom: -1px !important;
  }
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: ${COLORS.TAB};
    font-weight: 500;
    font-size: 16px;
  }

  .ant-tabs-nav::before {
    border: none !important;
  }
  .ant-tabs-nav-list {
    border-bottom: 2px solid #80808033;
  }

  @media (min-width: 320px) and (max-width: 420px) {
    .ant-tabs-tab {
      margin: 0 !important;
    }
    .ant-tabs-nav .ant-tabs-nav-list {
      gap: 1rem;
    }
  }
  .scroll-container {
    overflow: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }
  .scroll-container::-webkit-scrollbar {
    display: none;
  }
`;

const StyledModal = styled(Modal)`
  .ant-modal-header {
    border-bottom: none;
    padding-top: 20px;
  }
  .ant-modal-title {
    font-weight: bold;
    font-weight: 1.2rem;
  }
  .ant-modal-body {
    padding-top: 0px;
  }
  .ant-modal-footer {
    display: none;
  }
  .ant-form-item-label {
    font-weight: 500;
  }
  .ant-picker {
    width: 100%;
  }
  .ant-picker-input > input[disabled],
  .ant-select-disabled.ant-select:not(.ant-select-customize-input)
    .ant-select-selector,
  .ant-input[disabled] {
    color: rgba(0, 0, 0, 1);
  }
`;

const StyledTable = styled(Table)`
  .ant-table {
    border: 1px solid #ccc;
    border-radius: 12px;
    overflow: hidden;
  }

  .ant-table-container {
    border-radius: 12px;
  }

  .ant-table-content {
    overflow-x: auto;
  }

  table {
    width: 100%;
    min-width: 900px;
  }

  .ant-table-cell {
    padding: 16px;
    white-space: nowrap;
  }

  .ant-table-thead .ant-table-cell {
    font-weight: 600;
    color: ${COLORS.SECONDARY_BLACK};
  }
  .ant-table-tbody > tr > td {
    border-bottom: none !important;
  }

  .reason-column {
    min-width: 280px;
    white-space: normal;
  }

  .non-white {
    background: #f9f9f9;
  }
  .highlighted-row td {
    background-color: #22c55e !important;
    color: #fff !important;
    font-weight: 600;
  }

  .highlighted-row:hover td {
    background-color: #16a34a !important;
  }

  @media (max-width: 768px) {
    .ant-table-cell {
      padding: 10px;
      font-size: 12px;
    }
  }
`;

const prefixIds = (questions = [], prefix) =>
  questions.map((q) => ({ ...q, id: `${prefix}__${q.id}` }));

const isQuestionAnswered = (question) => {
  if (question.formType === "CHECKBOX") {
    return question.options?.some((opt) => opt.isChecked === true);
  }
  return (
    question.answer !== undefined &&
    question.answer !== null &&
    question.answer !== ""
  );
};

const HrReview = () => {
  const location = useLocation();
  const history = useHistory();
  const KpiData = location.state?.dataList;
  console.log("kpiData-->", KpiData);
  const isView = location.state?.isview || false;
  const [dataList, setDataList] = useState({});
  console.log("dataList-->", dataList);
  const [isViewKpi, setIsViewKpi] = useState(false);
  const [loading, setLoading] = useState(false);
  const [tabId, setTabId] = useState("1");
  const [remarkTabId, setRemarkTabId] = useState("1");
  const departmentList = useSelector(getAllDepartmentList);
  const [historyList, setHistoryList] = useState([]);
  const userInfo = useSelector(getUserInfo);

  // ── Appraisee (read-only view) ──────────────────────────────
  const [introductoryDetail, setIntroductoryDetail] = useState([]);
  const [mainSectionDetail, setMainSectionDetail] = useState([]);
  const [remarkSectionDetail, setRemarkSectionDetail] = useState([]);

  // ── Appraiser (editable) ────────────────────────────────────
  const [appraisarIntroductoryDetail, setAppraisarIntroductoryDetail] =
    useState([]);
  const [appraisarMainSectionDetail, setAppraisarMainSectionDetail] = useState(
    []
  );
  const [appraisarRemarkSectionDetail, setAppraisarRemarkSectionDetail] =
    useState([]);
  const [tableData, setTableData] = useState([]);
  const [data, setData] = useState([]);

  const [submitLoading, setSubmitLoading] = useState(false);
  const [draftLoading, setDraftLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});

  // Separate refs for appraisee and appraiser sections
  const appraiseeIntroRef = useRef({ deleteStatus: false, questions: [] });
  const appraiseeMainRef = useRef({ deleteStatus: false, questions: [] });
  const appraiseeRemarkRef = useRef({ deleteStatus: false, questions: [] });
  const appraiserIntroRef = useRef({ deleteStatus: false, questions: [] });
  const appraiserMainRef = useRef({ deleteStatus: false, questions: [] });
  const appraiserRemarkRef = useRef({ deleteStatus: false, questions: [] });

  const scoreConfig = useMemo(() => {
    return tableData.map((_, index) => ({
      key: `score${index + 1}`,
      label: `Score ${index + 1}`,
      from: 0,
    }));
  }, [tableData.length]);

  const onChange = (key) => {
    setTabId(key);
  };

  const items = [
    {
      key: "1",
      label: "Appraisee",
    },
    { key: "2", label: "Appraiser" },
  ];

  const remarkOnChange = (key) => {
    setRemarkTabId(key);
  };

  const remarkItems = [
    {
      key: "1",
      label: "Appraisee",
    },
    { key: "2", label: "Appraiser" },
  ];

  const handleSetIntroductory = useCallback(
    (val) => setAppraisarIntroductoryDetail(val),
    []
  );

  const ratingSummary = useMemo(() => {
    const ratingQuestions = appraisarMainSectionDetail.filter(
      (q) => q.formType === "RATING"
    );
    const totalStars = ratingQuestions.reduce(
      (sum, q) => sum + (q.starCount || 5),
      0
    );
    const totalValue = ratingQuestions.reduce(
      (sum, q) => sum + (Number(q.answer) || 0),
      0
    );
    const percentage = totalStars > 0 ? (totalValue / totalStars) * 100 : 0;
    return { totalStars, totalValue, percentage };
  }, [appraisarMainSectionDetail]);

  const getMatchingScoreKey = () => {
    if (!ratingSummary) return null;
    const percentage = ratingSummary.percentage;
    // find which score row matches the percentage in the first table
    const matchedRow = tableData?.find((record) => {
      const from = Number(record?.salaryfrom);
      const to = Number(record?.salaryto);
      return percentage >= from && percentage <= to;
    });
    return matchedRow ? `score${matchedRow.id}` : null; // e.g. "score4"
  };

  const matchingScoreKey = getMatchingScoreKey();

  const getPreviousScoreTo = (rowKey, scoreIndex) => {
    const currentRow = data.find((row) => row.key === rowKey);

    if (scoreIndex === 0) {
      // For first score of any row, get the previous row's score5 value
      const currentRowIndex = data.findIndex((row) => row.key === rowKey);
      if (currentRowIndex > 0) {
        const previousRow = data[currentRowIndex - 1];
        return previousRow?.score5 || 0;
      }
      return 0;
    }

    // For other scores, get the previous score's value from the same row
    const previousScoreKey = scoreConfig[scoreIndex - 1].key;
    const value = currentRow?.[previousScoreKey];

    return value || value === 0 ? value : 0;
  };

  const salaryColumns = [
    {
      title: "Experience (Yrs)",
      dataIndex: "experience",
    },
    ...scoreConfig.map((score, scoreIndex) => ({
      title: score.label,

      onCell: () => ({
        style:
          score.key === matchingScoreKey
            ? {
                backgroundColor: "#22c55e",
                color: "#fff",
                fontWeight: 600,
              }
            : {},
      }),
      render: (_, record) => {
        const fromValue = getPreviousScoreTo(record.key, scoreIndex);
        const isDisabled = scoreIndex !== 0 && fromValue === 0;
        // ||
        // (record[score.key] !== null &&
        //   record[score.key] !== undefined &&
        //   record[score.key] !== "");

        return (
          <>
            {fromValue || fromValue === 0 ? fromValue : score.from} -{" "}
            {record[score.key]} %
          </>
        );
      },
    })),
  ].filter(Boolean);

  const getHighlightedRow = (record) => {
    if (!ratingSummary) return "";
    const percentage = ratingSummary.percentage;
    const from = Number(record?.salaryfrom);
    const to = Number(record?.salaryto);
    if (percentage >= from && percentage <= to) return "highlighted-row";
    return "";
  };

  const columns = [
    {
      title: "Score",
      dataIndex: "id",
      key: "id",
      width: "10%",
    },
    {
      title: "Score Range (%)",
      dataIndex: "salaryto",
      key: "salaryto",
      width: "30%",
      render: (text, record, index) => (
        <>
          {record?.salaryfrom} - {record?.salaryto} %
        </>
      ),
    },
    {
      title: "Label",
      dataIndex: "label",
      key: "label",
      width: "30%",
      render: (text, record, index) => (
        <>
          <div className="text-wrap">{record?.label}</div>
        </>
      ),
    },
    {
      title: "Performance Description",
      dataIndex: "description",
      key: "description",
      width: "10%",
      render: (text, record, index) => (
        <>
          <div className="text-wrap">{record?.description}</div>
        </>
      ),
    },
  ].filter(Boolean);
  const handleSetMain = useCallback(
    (val) => setAppraisarMainSectionDetail(val),
    []
  );
  const handleSetRemark = useCallback(
    (val) => setAppraisarRemarkSectionDetail(val),
    []
  );

  const handleClearError = useCallback((questionId) => {
    setValidationErrors((prev) => {
      if (!prev[questionId]) return prev;
      const updated = { ...prev };
      delete updated[questionId];
      return updated;
    });
  }, []);

  const stripPrefix = (questions = []) =>
    questions.map((q) => ({
      ...q,
      id: q.id.includes("__") ? q.id.split("__")[1] : q.id,
    }));

  // ── Rating summary (appraiser main section only) ────────────

  console.log("ratingSummary", ratingSummary);

  // ── Self score (appraisee main section, read-only) ──────────
  const selfRatingSummary = useMemo(() => {
    const ratingQuestions = mainSectionDetail.filter(
      (q) => q.formType === "RATING"
    );
    const totalStars = ratingQuestions.reduce(
      (sum, q) => sum + (q.starCount || 5),
      0
    );
    const totalValue = ratingQuestions.reduce(
      (sum, q) => sum + (Number(q.answer) || 0),
      0
    );
    const percentage = totalStars > 0 ? (totalValue / totalStars) * 100 : 0;
    return { totalStars, totalValue, percentage };
  }, [mainSectionDetail]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const { data, code } = await CALL_API(
        `performance/HRView/${KpiData?.id}`, // ✅ fixed URL
        "get"
      );
      if (code === STATUS_CODE.SUCCESS) {
        setDataList(data[0]);
        setTableData(data[0]?.salaryincpercentage);
        setData(data[0]?.scoreclassification);
        setLoading(false);
      } else {
        throw new Error(`Failed to fetch data: ${code}`);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  const fetchHistoryData = async () => {
    setLoading(true);
    try {
      const { historyList, code } = await CALL_API(
        `performance/appraisalhisorty/${KpiData?.appraiseeuserid}`,
        "get"
      );
      if (code === STATUS_CODE.SUCCESS) {
        setHistoryList(historyList);
      } else {
        throw new Error(`Failed to fetch data: ${code}`);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    fetchHistoryData();
  }, []);

  useEffect(() => {
    // ── Appraisee sections (read-only) ──
    if (dataList?.introductorysection) {
      const prefixed = prefixIds(
        dataList.introductorysection,
        "appraisee_intro"
      );
      setIntroductoryDetail(prefixed);
      appraiseeIntroRef.current.questions = prefixed;
    }
    if (dataList?.mainquestionnairesection) {
      const prefixed = prefixIds(
        dataList.mainquestionnairesection,
        "appraisee_main"
      );
      setMainSectionDetail(prefixed);
      appraiseeMainRef.current.questions = prefixed;
    }
    if (dataList?.remarkssection) {
      const prefixed = prefixIds(dataList.remarkssection, "appraisee_remark");
      setRemarkSectionDetail(prefixed);
      appraiseeRemarkRef.current.questions = prefixed;
    }

    // ── Appraiser sections (editable) ──
    if (dataList?.appraiserintroductorysection) {
      const prefixed = prefixIds(
        dataList.appraiserintroductorysection,
        "intro"
      );
      setAppraisarIntroductoryDetail(prefixed);
      appraiserIntroRef.current.questions = prefixed;
    }
    if (dataList?.appraisermainquestionnairesection) {
      const prefixed = prefixIds(
        dataList.appraisermainquestionnairesection,
        "main"
      );
      setAppraisarMainSectionDetail(prefixed);
      appraiserMainRef.current.questions = prefixed;
    }
    if (dataList?.appraiserremarkssection) {
      const prefixed = prefixIds(dataList.appraiserremarkssection, "remark");
      setAppraisarRemarkSectionDetail(prefixed);
      appraiserRemarkRef.current.questions = prefixed;
    }
  }, [dataList]);

  const onCompleteClick = async () => {
    const errors = {};
    [
      ...appraisarIntroductoryDetail,
      ...appraisarMainSectionDetail,
      ...appraisarRemarkSectionDetail,
    ]
      .filter((q) => q.question && q?.requiredSwitch)
      .forEach((q) => {
        if (!isQuestionAnswered(q)) errors[q.id] = true;
      });

    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      const firstErrorId = Object.keys(errors)[0];
      const el = document.getElementById(`question-${firstErrorId}`);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
      return;
    }

    setValidationErrors({});
    setSubmitLoading(true);

    const payload = {
      reviewedon: dayjs().format("DD-MM-YYYY") || "",
      appraisermainquestionnairesection:
        stripPrefix(appraisarMainSectionDetail) || [],
      appraiserintroductorysection:
        stripPrefix(appraisarIntroductoryDetail) || [],
      appraiserremarkssection: stripPrefix(appraisarRemarkSectionDetail) || [],
      scoreclassification: [],
      salaryincpercentage: [],
      reviewstatus: "1",
    };

    const { code } = await CALL_API(
      `performance/reviewappraisal/${KpiData?.id}`,
      "patch",
      payload
    );
    if (code === STATUS_CODE.SUCCESS) {
      setSubmitLoading(false);
      history.push("/performance");
    } else {
      setSubmitLoading(false);
    }
  };

  const onSaveAsDraftClick = async () => {
    setDraftLoading(true);

    const payload = {
      reviewedon: dayjs().format("DD-MM-YYYY") || "",
      appraisermainquestionnairesection:
        stripPrefix(appraisarMainSectionDetail) || [],
      appraiserintroductorysection:
        stripPrefix(appraisarIntroductoryDetail) || [],
      appraiserremarkssection: stripPrefix(appraisarRemarkSectionDetail) || [],
      scoreclassification: [],
      salaryincpercentage: [],
      reviewstatus: "0",
    };

    const { code } = await CALL_API(
      `performance/reviewappraisal/${KpiData?.id}`,
      "patch",
      payload
    );
    if (code === STATUS_CODE.SUCCESS) {
      setDraftLoading(false);
      history.push("/performance");
    } else {
      setDraftLoading(false);
    }
  };

  const footerStyle = {
    position: "sticky",
    bottom: 0, // ✅ fixed from -20
    left: 0,
    right: 0,
    backgroundColor: "#fff",
    padding: "10px",
    display: "flex",
    justifyContent: "end",
    boxShadow: "0 -2px 10px rgba(0, 0, 0, 0.1)",
    margin: "0px -20px",
    zIndex: 10,
  };

  return (
    <AttendWrap>
      <StyledModal
        title={"Appraisee's KPI"}
        visible={isViewKpi}
        onCancel={() => setIsViewKpi(false)}
        width={800}
        footer={[]}
      >
        <ViewKpi dataList={dataList} />
      </StyledModal>

      <Spin spinning={loading}>
        <div>
          <div className="breadcrumb">
            <p
              className="lite-text p-0 m-0"
              style={{ cursor: "pointer" }}
              onClick={() => history.push("/performance", { id: "3" })}
            >
              Performance
            </p>
            &nbsp;
            <RightOutlined className="mt-1" />
            &nbsp;
            <p className="m-0 p-0 text-bold">
              {KpiData?.fullname} - {KpiData?.title}
            </p>
          </div>

          {/* Employee Info */}
          <div className="mb-3">
            <Row gutter={[16, 16]} style={{ marginRight: "0px" }}>
              <Col xs={24} md={12}>
                <Row gutter={16}>
                  <Col xs={24} md={12} className="lite-text">
                    Name of the Employee
                  </Col>
                  <Col xs={24} md={12} className="text-bold">
                    {KpiData?.fullname || "-"}
                  </Col>
                </Row>
              </Col>
              <Col xs={24} md={12}>
                <Row gutter={16}>
                  <Col xs={24} md={12} className="lite-text">
                    Departments
                  </Col>
                  <Col xs={24} md={12} className="text-bold">
                    {KpiData?.departmentname || "-"}
                  </Col>
                </Row>
              </Col>
              <Col xs={24} md={12}>
                <Row gutter={16}>
                  <Col xs={24} md={12} className="lite-text">
                    Title
                  </Col>
                  <Col xs={24} md={12} className="text-bold">
                    {KpiData?.title || "-"}
                  </Col>
                </Row>
              </Col>
              <Col xs={24} md={12}>
                <Row gutter={16}>
                  <Col xs={24} md={12} className="lite-text">
                    KPI Template
                  </Col>
                  <Col xs={24} md={12} className="text-bold">
                    {KpiData?.templatename || "-"}
                  </Col>
                </Row>
              </Col>
              <Col xs={24} md={12}>
                <Row gutter={16}>
                  <Col xs={24} md={12} className="lite-text">
                    Hired Date
                  </Col>
                  <Col xs={24} md={12} className="text-bold">
                    {KpiData?.hireddate || "-"}
                  </Col>
                </Row>
              </Col>
              <Col xs={24} md={12}>
                <Row gutter={16}>
                  <Col xs={24} md={12} className="lite-text">
                    Type
                  </Col>
                  <Col xs={24} md={12} className="text-bold">
                    {KpiData?.type || "-"}
                  </Col>
                </Row>
              </Col>
              <Col xs={24} md={12}>
                <Row gutter={16}>
                  <Col xs={24} md={12} className="lite-text">
                    Start date to attend appraisal
                  </Col>
                  <Col xs={24} md={12} className="text-bold">
                    {dayjs(KpiData?.attendstartdate).format("DD-MM-YYYY") ||
                      "-"}
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>

          {/* ── Appraisee answers (read-only) ── */}
          <h6>Introductory Section</h6>
          <Tabs activeKey={tabId} items={items} onChange={onChange} />
          {tabId === "1" ? (
            <>
              {introductoryDetail?.[0]?.question ? (
                <>
                  <AnswerForm
                    fullFormDetail={introductoryDetail}
                    selectedItem={appraiseeIntroRef.current}
                    setAnswerResponse={() => {}}
                    validationErrors={{}}
                    onClearError={() => {}}
                    isView={true}
                  />
                </>
              ) : (
                <div className="nodata">No Response yet</div>
              )}
            </>
          ) : (
            <>
              {appraisarIntroductoryDetail?.[0]?.question ? (
                <>
                  <AnswerForm
                    fullFormDetail={appraisarIntroductoryDetail}
                    selectedItem={appraiserIntroRef.current}
                    setAnswerResponse={handleSetIntroductory}
                    validationErrors={validationErrors}
                    onClearError={handleClearError}
                    isView={true}
                  />
                </>
              ) : (
                <div className="nodata">No Response yet</div>
              )}
            </>
          )}

          <>
            <h6 className="mt-5">
              Main Questionnaire Section <span className="text-danger">*</span>
            </h6>
            <MainQuestionnaireTable
              appraiseeQuestions={mainSectionDetail}
              appraiserQuestions={appraisarMainSectionDetail}
              isView={isView}
              validationErrors={validationErrors}
              onAppraiserChange={(updated) => {
                setAppraisarMainSectionDetail(updated);
                appraiserMainRef.current.questions = updated;
              }}
            />
          </>

          <h6 className="mt-5">Remarks & Feedback Section</h6>
          <Tabs
            activeKey={remarkTabId}
            items={remarkItems}
            onChange={remarkOnChange}
          />

          {remarkTabId === "1" ? (
            <>
              {remarkSectionDetail?.[0]?.question ? (
                <>
                  <AnswerForm
                    fullFormDetail={remarkSectionDetail}
                    selectedItem={appraiseeRemarkRef.current}
                    setAnswerResponse={() => {}}
                    validationErrors={{}}
                    onClearError={() => {}}
                    isView={true}
                  />
                </>
              ) : (
                <div className="nodata">No Response yet</div>
              )}
            </>
          ) : (
            <>
              {appraisarRemarkSectionDetail?.[0]?.question ? (
                <>
                  <AnswerForm
                    fullFormDetail={appraisarRemarkSectionDetail}
                    selectedItem={appraiserRemarkRef.current}
                    setAnswerResponse={handleSetRemark}
                    validationErrors={validationErrors}
                    onClearError={handleClearError}
                    isView={true}
                  />
                </>
              ) : (
                <div className="nodata">No Response yet</div>
              )}
            </>
          )}
          <br></br>
          <br />
          {dataList?.reviewedon && dataList?.attendedon && (
            <>
              <h6 className="mb-3">
                Performance Score & Salary Increment percentage
              </h6>
              <h6>Score Classification</h6>
              <p className="lite-text">
                This table maps the final score from the Main Questionnaire
                Section to predefined performance categories. Based on the
                appraiser’s evaluation, the appraisee is automatically placed
                into the appropriate score range, helping HR and managers
                clearly identify performance level and ensure consistent,
                objective appraisal outcomes across roles.
              </p>
              <StyledTable
                dataSource={tableData}
                columns={columns}
                className="small_table mb-3"
                rowKey="key"
                pagination={false}
                rowClassName={(record) => getHighlightedRow(record)}
              />
            </>
          )}
        </div>
        {dataList?.reviewedon && dataList?.attendedon && (
          <>
            <h6>Salary increment percentage</h6>
            <p className="lite-text">
              This table defines the percentage of salary increase applicable to
              each performance score range. Based on the appraiser’s final
              evaluation score from the Main Questionnaire Section, the system
              highlights the eligible increment bracket, ensuring fair,
              transparent, and performance-driven compensation decisions.
            </p>
            <StyledTable
              columns={salaryColumns}
              dataSource={data}
              className="small_table mb-5"
              pagination={false}
            />
          </>
        )}
        <br />
        <UserFloatingButton
          isViewKpi={isViewKpi}
          setIsViewKpi={setIsViewKpi}
          bottompossition={"20px"}
        />
      </Spin>
      <KPIHistory />
      <FloatingHistoryButton
        historyList={historyList?.filter((item) => item?.kpiid === KpiData?.id)}
        currentUserEmail={userInfo?.userid}
      />
    </AttendWrap>
  );
};

export default HrReview;
